import { APP_VERSION } from './constants'

console.log('version: ' + APP_VERSION)

import Vue from 'vue'
import './bootstrap'
import './bugsnag'
import'./filters'
import {sync} from "vuex-router-sync";

import store from '@/store'

store.dispatch('e/users/restoreToken').then(()=>{}).catch((e)=>{})

import router from '@/router'
sync(store, router)



import AppLayout from './App.vue'
new Vue({...AppLayout, store, router}).$mount("#app")
